<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar color="blue-grey">
        <v-toolbar-title>Categories</v-toolbar-title>
        <!--
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>
        -->
      </v-toolbar>
      <v-card>
        <v-container
          fluid
          grid-list-md
        >
          <v-layout row wrap>
            <v-flex
              v-for="item in items"
              :key="item.title"
              xs6 sm3 lg2
            >
              <v-card
                color="cyan darken-3"
                style="cursor:pointer;"
                @click="getChallenges(item.title)"
              >
                <v-img
                  :src="item.cover"
                  height="200px"
                ></v-img>

                <v-card-actions>
                  {{ item.title }}
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-snackbar
          v-model="snackbar"
          :color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    data () {
      return {
        snackbar: false,
        error: "",
        categories: [],
        items: []
      }
    },
    methods: {
      getChallenges (title) {
        this.$router.push({
          name: 'challenges',
          query: {
            category: title
          }
        });
      },
      populateItems () {
        this.categories.map((category, idx) => {
          let item = {
            id: category.id,
            cover: 'img/category.png',
            title: category.title
          };

          if (category.challenges.length == 0) {
            return;
          }

          if (category.covers.length == 1) {
            item.cover = category.covers[0].url;
          }
          else if (category.covers.length > 0) {
            let min = 0, max = category.covers.length - 1;
            let random = Math.floor(Math.random() * (+max - +min)) + +min;

            item.cover = category.covers[random].url;
          }

          this.items.push(item);
        });
      }
    },
    created () {
      this.$http.api.checkLogin();
    },
    mounted () {
      this.$http.api.get('/categories?_sort=title%3AASC')
      .then(response => {
        this.categories = response.data;

        this.populateItems();
      })
      .catch(error => {
        if (error.response) {
          this.error = this.$http.api.getError(error).toString;
          this.snackbar = true;
        }
        else {
          console.dir(error);
        }
      });
    }
  }
</script>